if(!customElements.get('related-products')) {
  customElements.define(
    'related-products',
    class RelatedProducts extends HTMLElement {
      observer = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.initializeWhenVisible();
      }

      initSlider() {
        const sliderEl = this.querySelector('[data-slider]');
        if(!sliderEl) {
          return console.error('An error ocurred while trying to initialize related products slider');
        }

        this.sliderInstance = new Swiper(sliderEl, {
          slidesPerView: 1.3,
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 16
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 16
            }
          },
          navigation: {
            prevEl: '.related-products-slider-button.slider-button.prev',
            nextEl: '.related-products-slider-button.slider-button.next',
          },
          pagination: {
            el: '.related-products-slider-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      }

      initializeWhenVisible() {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.initSlider();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      }
    }
  )
}